import { Controller } from "@hotwired/stimulus"
import {
  Chart,
  LineController, BarController,
  LineElement, PointElement, BarElement,
  CategoryScale, LinearScale,
  Tooltip, Legend, Filler
} from "chart.js"

Chart.register(
  LineController, BarController,
  LineElement, PointElement, BarElement,
  CategoryScale, LinearScale,
  Tooltip, Legend, Filler
)

// Generic Chart.js wrapper. The view embeds the full Chart.js config as
// JSON in data attributes (no JSON API). Stimulus parses Object values.
export default class extends Controller {
  static targets = ["canvas"]
  static values = { type: String, data: Object, options: Object }

  connect() {
    this.chart = new Chart(this.canvasTarget, {
      type: this.typeValue,
      data: this.dataValue,
      options: {
        responsive: true,
        maintainAspectRatio: false,
        ...this.optionsValue
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
      this.chart = null
    }
  }
}
